import { useRef } from "react";
import { motion, useReducedMotion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, as = "div", className = "", ...rest }) => {
  const reduce = useReducedMotion();
  const M = motion[as];
  return (
    <M
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const MaskedTitle = ({ children, as = "h2", className = "", delay = 0, ...rest }) => {
  const reduce = useReducedMotion();
  const Tag = as;
  // On observe le titre lui-même (pas le texte caché dessous) : sinon un titre sur 2 lignes ou plus ne se révélait jamais.
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-60px" });
  return (
    <Tag ref={ref} className={`overflow-hidden pb-[0.12em] ${className}`} {...rest}>
      <motion.span
        className="block"
        initial={reduce ? false : { y: "108%" }}
        animate={reduce || seen ? { y: 0 } : { y: "108%" }}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </Tag>
  );
};

export const GoldLine = ({ className = "", vertical = false }) => {
  const reduce = useReducedMotion();
  return (
    <motion.span
      aria-hidden="true"
      className={`block bg-copper/70 ${vertical ? "w-px h-full origin-top" : "h-px w-full origin-left"} ${className}`}
      initial={reduce ? false : vertical ? { scaleY: 0 } : { scaleX: 0 }}
      whileInView={vertical ? { scaleY: 1 } : { scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.6, ease: EASE }}
    />
  );
};

export const Eyebrow = ({ children, tone = "plum", className = "" }) => (
  <p className={`flex items-center gap-4 text-[0.7rem] uppercase tracking-[0.35em] ${tone === "white" ? "text-plum" : "text-copper"} ${className}`}>
    <span className="h-px w-10 bg-current" aria-hidden="true" />
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, title, intro, tone = "plum", className = "", testid }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <Reveal><Eyebrow tone={tone}>{eyebrow}</Eyebrow></Reveal>}
    <MaskedTitle className="mt-6 font-serif text-2xl md:text-[1.75rem] leading-[1.12] tracking-tight" data-testid={testid}>{title}</MaskedTitle>
    {intro && <Reveal delay={0.15} className={`mt-6 text-base leading-relaxed ${tone === "white" ? "text-brown/90" : "text-white/75"}`}><p>{intro}</p></Reveal>}
  </div>
);
